import { render, staticRenderFns } from "./AdminCustomerFilters.vue?vue&type=template&id=3860a4a7"
import script from "./AdminCustomerFilters.vue?vue&type=script&lang=js"
export * from "./AdminCustomerFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports